import script from "./AddressMismatch.vue?vue&type=script&setup=true&lang=ts"
export * from "./AddressMismatch.vue?vue&type=script&setup=true&lang=ts"

import "./AddressMismatch.vue?vue&type=style&index=0&id=292b1af1&scoped=true&lang=scss"

import exportComponent from "D:\\a\\1\\s\\src\\ApplicantPortal.Web\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-292b1af1"]])

export default __exports__